import { Pipe, PipeTransform } from '@angular/core';

import { formatPercent } from '@app/core/services/metrics-calculations.service';

@Pipe({ name: 'formatPercent' })
export class FormatPercentPipe implements PipeTransform {
  transform(value: string | number | Date, ignoreFormat = false, minimumFractionDigits = 2): string {
    return formatPercent(value, ignoreFormat, minimumFractionDigits);
  }
}
